export default [
  "Cloth",
  "SheetMetal",
  "Power",
  "GearShirtBase",
  "SuitShirt",
  "GearPantsBase",
  "SuitPants",
  "SuitShoes",
  "Gasoline",
  "TwoByFour",
  "Nails",
  "Hammer",
  "Hose",
  "Shovel",
  "SparkPlug",
  "ScrewDriver",
  "Saw",
  "Plywood",
  "Item_IdCard",
  "BulletItemDefinitionBase",
  "Item_45",
  "Item_556x45",
  "Item_762x39",
  "Item_762x51",
  "Item_9x19",
  "AK47_Magazine",
  "M14_Magazine",
  "P320_Magazine",
  "Stanag_Magazine",
  "Stanag_Magazine_Extended",
  "CamoBoots",
  "CargoPants",
  "HikingBackpack",
  "LongSleeve",
  "MagazinePouch",
  "MilitaryHeavyVest",
  "MilitaryVest",
  "PocketPouch",
  "SquareBackpack",
  "Bandage",
  "Medkit_Small",
  "Morphine",
  "PainKillers",
  "RedDot",
  "Scope4x",
  "Suppressor",
  "M14",
  "P320",
  "Scar",
  "LaserSight06",
  "Cigarettes",
  "Soap",
  "ToiletPaper",
  "Figure_1",
  "Figure_2",
  "Figure_3",
  "Apple1",
  "Apple2",
  "Banana",
  "Melon",
  "PeanutButter",
  "Watermelon",
  "BlueJeans",
  "CombatBoots",
  "Hoodie",
  "MegaBackpack",
  "NVG",
  "SchoolBackpack",
  "TShirtBlue",
  "SchoolOfficeKey",
  "Item_BlueCard",
  "Money",
  "DuctTape",
  "ElectricalTape",
  "Flashlight",
  "GoldenHammer",
  "Lubricant",
  "Pliers",
  "SprayPaint",
  "TapeMeasure",
  "Wrench",
  "Beret",
  "CamoJacket",
  "CamoPants",
  "CombatGloves",
  "FannyPack",
  "FullHelmet",
  "G4Backpack",
  "MilitaryFullVest",
  "MilitaryHeadset",
  "Scarf",
  "TacticalHelmet",
  "TacticalLongsleeve",
  "CarboyGarageKey",
  "Item_GreenCard",
  "Item_12g_00_Buckshot",
  "Item_12g_Slug",
  "Item_308",
  "Item_45_LR",
  "Item_556x45_AP",
  "Item_762x39_LR",
  "Item_762x51_LR",
  "Item_9x19_LR",
  "Compensator",
  "Item_R700_Magazine",
  "Item_R700_Scope",
  "MP5_Magazine",
  "MuzzleBrake",
  "UMP45_Magazine",
  "AK47",
  "MP5",
  "R700",
  "R870",
  "UMP45",
  "Water",
  "WoodStick",
  "WoodLog",
  "WoodKindling",
  "Pipe",
  "Figure_5",
  "Figure_4",
  "Item_PinkCard",
  "Item_Note",
  "Shorts",
  "Sandals",
  "FaceMask",
  "CountryHat",
  "CasualShoes",
  "BaseballHat",
  "OfficeTrailer_Key",
  "Item_PriestKey",
  "Item_Key3",
  "Item_Key2",
  "BunkerGarageKey",
  "120Key",
  "116Key",
  "113RoomKey",
  "112RoomKey",
  "109RoomKey",
  "108Key",
  "105Key",
  "104Key",
  "101Key",
  "100Key",
  "VenisonSteak",
  "Venison",
  "WeaponFlashlight",
  "VerticalGrip",
  "Scope2x",
  "AngledGrip",
  "Binoculars",
  "Comic1",
  "WeaponContainer",
  "WaterBottle",
  "SmallAmmoContainer",
  "MedicalContainer",
  "GasCan",
  "DuffleBag",
  "BatteryAA",
  "Battery9V",
  "Soda",
  "EnergyDrink",
  "Cereal",
  "Beer",
  "Mk2_Grenade",
  "PlasticDrum",
  "Generator",
  "Tourniquet",
  "SplintKit",
  "SalineIV",
  "Antiseptic",
  "Antibiotics",
  "SleepingBag",
  "FuelCanister",
  "Propane",
  "CampStove",
  "CampFire",
  "Scissors",
  "RepairKit",
  "Knife",
  "Explosive",
  "BoltCutters",
  "Axe",
];
